import React, { useContext } from 'react'
import { EventContext, EventProvider } from './EventContext'
import HTag from '@/lib/HTag'
import CalendarFilter from './CalendarFilter'
import { Calendar, momentLocalizer } from 'react-big-calendar'
import components from './CalendarComponents'
import moment from 'moment'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import * as css from './EventCalendar.module.css'

const localizer = momentLocalizer(moment)

const App = ({ heading }) => {
	const { events, $type } = useContext(EventContext)

	const filteredEvents = events
		.filter(({ type }) => !$type || type === $type)
		.reduce((unique, event) => {
			const isDuplicate = unique.find(item =>
				item.start === event.start &&
				item.title === event.title
			)
			if (!isDuplicate) {
				unique.push(event)
			}
			return unique
		}, [])

	return (
		<section className="section">
			<HTag className="h1 text-center" {...heading} />

			<CalendarFilter />

			<Calendar
				className={`${css.calendar} mt-8`} style={{ minHeight: 700 }}
				localizer={localizer}
				events={filteredEvents}
				drilldownView="agenda"
				startAccessor="start"
				endAccessor="end"
				views={{
					month: true,
					agenda: true
				}}
				components={components}
			/>
		</section>
	)
}

const EventCalendar = props => <EventProvider children={<App {...props} />} />

export default EventCalendar
